'use client';

import { c as _c } from "react/compiler-runtime";
import { useElementViewed } from '@cc-shopping/platform-analytics/hooks/useElementViewed';
import { useTrackElementInteracted } from '@cc-shopping/platform-analytics/hooks/useTrackElementInteracted';
import { SpeculationRulesScript } from '@cc-shopping/utils/speculationRules/SpeculationRulesScript';
import clsx from 'clsx';
import { ENTITY_NAME, GET_MATCHED_BUTTON_ENTITY_NAME, REDIRECT_DESTINATION, SECTION_NAME } from './constants';
import { getCardfinderTravelUrl } from './getCardfinderTravelUrl';
import { PostSignupHeader } from './PostSignupHeader';
const CARDFINDER_TRAVEL_URL = getCardfinderTravelUrl();
// Uses moderate eagerness so the rule only fires if the user hovers over the CTA
const speculationRules = {
  prerender: [{
    source: 'document',
    where: {
      href_matches: CARDFINDER_TRAVEL_URL
    },
    eagerness: 'moderate'
  }]
};
export function ManualCtaVariant() {
  const $ = _c(11);
  const trackElementInteracted = useTrackElementInteracted();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      entityName: ENTITY_NAME,
      sectionName: SECTION_NAME
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    ref,
    eventId: parentEventId
  } = useElementViewed(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SpeculationRulesScript id="cardfinder-cta-speculation-rules" rules={speculationRules} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== parentEventId || $[3] !== trackElementInteracted) {
    t2 = () => trackElementInteracted({
      entityName: GET_MATCHED_BUTTON_ENTITY_NAME,
      parentEventId,
      interactionType: "click",
      itemCopy: "get_matched",
      additionalAttributes: {
        redirect_destination: REDIRECT_DESTINATION
      }
    });
    $[2] = parentEventId;
    $[3] = trackElementInteracted;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = clsx("flex", "items-center", "justify-center", "h-11", "w-auto", "sm:max-w-76", "px-8", "rounded", "bg-green-default", "hover:bg-green-dark", "text-white", "text-small", "font-bold", "uppercase", "tracking-[0.65px]", "no-underline");
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <PostSignupHeader><a href={CARDFINDER_TRAVEL_URL} onClick={t2} className={t3}>Get matched</a></PostSignupHeader>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== ref || $[9] !== t4) {
    t5 = <div ref={ref}>{t1}{t4}</div>;
    $[8] = ref;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}